import {SVGProps} from 'react';

interface ExternalLinkIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ExternalLinkIcon = ({
  className,
  ...props
}: ExternalLinkIconProps) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <path d="M15 3h6v6" />
    <path d="M10 14 21 3" />
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
  </svg>
);
